import { useMemo } from 'react';
import { useFilterContext } from '../context';
import { useFavouriteBrands } from 'entities/brands';

import { EMPTY_ARRAY } from 'common/constants';

export const useFilteredFavouriteBrands = () => {
  const { searchString } = useFilterContext();
  const favouriteBrands = useFavouriteBrands() || EMPTY_ARRAY;

  const filteredFavouriteBrands = useMemo(() => (
    favouriteBrands.filter(favouriteBrand => favouriteBrand.title.toLowerCase().includes(searchString.toLowerCase().trim()))
  ), [
    favouriteBrands,
    searchString
  ]);

  return filteredFavouriteBrands;
};
